import { API } from 'aws-amplify';
import { API_NAME, getConfig, validateResponse, handleError } from './apiUtils';

export function getLoyaltyConfig(market, category, brand) {
    const path = `/v1/loyaltyadmin/${market}/${category}/${brand}/portal-configuration`;
    return getConfig()
        .then((config) => API.get(API_NAME, path, config))
        .then(validateResponse)
        .catch(handleError);
}

export function updateLoyaltyConfig(market, category, brand, body) {
    const path = `/v1/loyaltyadmin/${market}/${category}/${brand}/portal-configuration`;
    return getConfig(body)
        .then((config) => API.put(API_NAME, path, config))
        .then(validateResponse)
        .catch(handleError);
}
